(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-floorball/assets/javascripts/match.js') >= 0) return;  svs.modules.push('/components/themes/sport-floorball/assets/javascripts/match.js'); 
var svs = svs || {};

(function(svs, _) {
  var logger = new svs.core.log.Logger('svs.themes.sport_floorball');

  svs.themes = svs.themes || {};
  svs.themes.sport_floorball = svs.themes.sport_floorball || {};
  svs.themes.sport_floorball.getLatestMatchesHomeAwayFilter = function() {
    return {
      all: { name: 'Alla', selected: true },
      home: { name: 'Hemma', selected: false },
      away: { name: 'Borta', selected: false }
    };
  };
  svs.themes.sport_floorball.formatModelData = function(data) {
    var status = 0;
    if (((data || {}).events || {}).status) {
      status = data.events.status;
    }

    if (this.isLive(status)) return this.doFormatModelDataLive(data);
    return this.doFormatModelData(data);
  };

  svs.themes.sport_floorball.doFormatModelDataLive = function(data) {
    var response = data,
      _self = this;

    response.events.chronologicalList = this.filterEvents(
      response.events.chronologicalList
    );

    response.events.chronologicalList = _.sortBy(
      response.events.chronologicalList,
      function(item) {
        return _self.useAvailableTime(item);
      }
    );

    this.removeInsufficientEvents(response.events.chronologicalList);

    if (_.isObject(response.events)) {
      if (_.isObject(response.events.chronologicalList)) {
        _.each(response.events.chronologicalList, function(eventItem) {
          if (_.isObject(eventItem.extendedTime)) {
            eventItem.formatedTime = eventItem.extendedTime.time;
            eventItem.period = eventItem.extendedTime.period;
          } else if (_.isString(eventItem.time)) {
            eventItem.formatedTime = eventItem.time;
          }
        });

        var groupedEvents = _.groupBy(
          response.events.chronologicalList,
          function(eventItem) {
            return eventItem.period;
          }
        );

        groupedEvents = this.formatGoalResult(groupedEvents);
        groupedEvents = _.sortBy(groupedEvents, function() {}).reverse();

        for (var i in groupedEvents) {
          if (Object.prototype.hasOwnProperty.call(groupedEvents, i)) {
            groupedEvents[i] = this.reverseSortAttrOnTime(groupedEvents[i]);
            var formatPeriodName = this.formatPeriodName(groupedEvents[i][0]);
            groupedEvents[i].periodName =
              formatPeriodName !== '' ? formatPeriodName : '';
            groupedEvents[i].periodResult = this.findPeriodResult(
              groupedEvents[i][0],
              response
            );
          }
        }

        response.events.groupedEvents = groupedEvents;
      }
    }
    return response;
  };
  svs.themes.sport_floorball.doFormatModelData = function(data) {
    var response = data,
      _self = this;
    response.events.goals = _.sortBy(response.events.goals, function(item) {
      return _self.useAvailableTime(item);
    });
    this.removeInsufficientEvents(response.events.goals);

    response.events.penalties = _.sortBy(response.events.penalties, function(
      item
    ) {
      return _self.useAvailableTime(item);
    });
    this.removeInsufficientEvents(response.events.penalties);

    if (_.isObject(response.events)) {
      if (_.isObject(response.events.goals)) {
        _.each(response.events.goals, function(goal) {
          if (_.isObject(goal.extendedTime)) {
            goal.formatedTime = goal.extendedTime.time;
            goal.period = goal.extendedTime.period;
          } else if (_.isString(goal.time)) {
            goal.formatedTime = goal.time;
          }
        });

        var groupedGoals = _.groupBy(response.events.goals, function(goal) {
          return goal.period;
        });
        groupedGoals = this.formatGoalResult(groupedGoals);
        groupedGoals = _.sortBy(groupedGoals, function() {}).reverse();

        for (var i in groupedGoals) {
          if (Object.prototype.hasOwnProperty.call(groupedGoals, i)) {
            groupedGoals[i] = this.reverseSortAttrOnTime(groupedGoals[i]);
            groupedGoals[i].periodName = this.formatPeriodName(
              groupedGoals[i][0]
            );
            groupedGoals[i].periodResult = this.findPeriodResult(
              groupedGoals[i][0],
              response
            );
          }
        }

        groupedGoals = _.reject(groupedGoals, function(goals) {
          return goals.periodName === 'Straffar';
        });

        response.events.shootout = _getShootout(response);
        response.events.groupedGoals = groupedGoals;
      }

      if (_.isObject(response.events.penalties)) {
        _.each(response.events.penalties, function(penalty) {
          if (_.isObject(penalty.extendedTime)) {
            penalty.formatedTime = penalty.extendedTime.time;
            penalty.period = penalty.extendedTime.period;
          } else if (_.isString(penalty.time)) {
            penalty.formatedTime = penalty.time;
          }
        });

        var groupedPenalties = _.groupBy(response.events.penalties, function(
          penalty
        ) {
          return penalty.extendedTime.period;
        });

        groupedPenalties = _.sortBy(groupedPenalties, function(item) {
          return parseInt(item, 10);
        }).reverse();

        for (var j in groupedPenalties) {
          if (Object.prototype.hasOwnProperty.call(groupedPenalties, j)) {
            groupedPenalties[j] = this.reverseSortAttrOnTime(
              groupedPenalties[j]
            );
            groupedPenalties[j].periodName = this.formatPeriodName(
              groupedPenalties[j][0]
            );
            groupedPenalties[j].periodResult = this.findPeriodResult(
              groupedPenalties[j][0],
              response
            );
          }
        }
        response.events.groupedPenalties = groupedPenalties;
      }
    }
    return response;
  };

  svs.themes.sport_floorball.groupEvents = function(response) {
    var _self = this;

    if (_.isObject(response) && _.has(response, 'matchEvents')) {
      response.matchEvents = _.sortBy(response.matchEvents, function(item) {
        return _self.useAvailableTime(item);
      });

      _.each(response.matchEvents, function(goal) {
        if (_.isObject(goal.extendedTime)) {
          goal.formatedTime = goal.extendedTime.time;
          goal.period = goal.extendedTime.period;
        } else if (_.isString(goal.time)) {
          goal.formatedTime = goal.time;
        }
      });

      var groupedGoals = _.groupBy(response.matchEvents, function(goal) {
        return goal.period;
      });
      groupedGoals = this.formatGoalResult(groupedGoals);
      groupedGoals = _.sortBy(groupedGoals, function() {}).reverse();

      for (var i in groupedGoals) {
        if (Object.prototype.hasOwnProperty.call(groupedGoals, i)) {
          groupedGoals[i] = this.reverseSortAttrOnTime(groupedGoals[i]);
        }
      }

      return groupedGoals;
    }
    return null;
  };

  svs.themes.sport_floorball.formatGoalResult = function(dataList) {
    var homeGoal = 0;
    var awayGoal = 0;
    var goalResult = [];
    var homeResult = 0;
    var awayResult = 0;
    _.each(dataList, function(data) {
      _.each(data, function(goal) {
        if (_.isString(goal.result)) {
          goalResult = goal.result.split('-');

          homeResult = goalResult[0];
          awayResult = goalResult[1];

          if (parseInt(homeResult, 10) > homeGoal) {
            goal.homeChange = true;
            homeGoal = parseInt(homeResult, 10);
          } else {
            goal.homeChange = false;
          }

          if (parseInt(awayResult, 10) > awayGoal) {
            goal.awayChange = true;
            awayGoal = parseInt(awayResult, 10);
          } else {
            goal.awayChange = false;
          }
        }
      });
    });
    return dataList;
  };

  svs.themes.sport_floorball.formatPeriodName = function(groupedDataItem) {
    var res = '';
    if (groupedDataItem.period === 1 || groupedDataItem.period === 2) {
      res = groupedDataItem.period + ':a perioden';
    } else if (groupedDataItem.period === 5) {
      res = 'Straffar';
    } else if (groupedDataItem.period !== undefined) {
      if (groupedDataItem.period > 3) {
        res = 'Övertid ' + groupedDataItem.period + ':e perioden';
      } else {
        res = groupedDataItem.period + ':e perioden';
      }
    }
    return res;
  };

  svs.themes.sport_floorball.removeInsufficientEvents = function(dataList) {
    var doRemove = false;
    for (var i = 0; i < dataList.length; i++) {
      doRemove = false;
      if (
        this.isPenaltyEvent(dataList[i]) ||
        this.isGoalEventLive(dataList[i]) ||
        this.isGoalEvent(dataList[i])
      ) {
        if (!(dataList[i].player || {}).name) {
          doRemove = true;
        }
      }

      if (doRemove) {
        dataList.splice(i, 1);
        i--;
      }
    }
  };

  svs.themes.sport_floorball.isPenaltyEvent = function(event) {
    return event.type === 'penalty';
  };

  svs.themes.sport_floorball.isGoalEventLive = function(event) {
    return event.type === 'goal';
  };

  svs.themes.sport_floorball.isGoalEvent = function(event) {
    return event.goalType >= 0;
  };

  svs.themes.sport_floorball.findPeriodResult = function(
    groupedDataItem,
    response
  ) {
    var FIRST_PERIOD = 5;
    var SECOND_PERIOD = 6;
    var THIRD_PERIOD = 7;
    var EXTRA_TIME = 3;
    var PENALTIES = 4;

    var oResult = response.events.result;

    switch (groupedDataItem.period) {
      case 1:
        return this.findPeriodResultById(FIRST_PERIOD, oResult);
      case 2:
        return this.findPeriodResultById(SECOND_PERIOD, oResult);
      case 3:
        return this.findPeriodResultById(THIRD_PERIOD, oResult);
      case 4:
        return this.findPeriodResultById(EXTRA_TIME, oResult);
      case 5:
        return this.findPeriodResultById(PENALTIES, oResult);
      default:
    }
  };

  svs.themes.sport_floorball.findPeriodResultById = function(needle, hay) {
    for (var i = 0; i < hay.length; i++) {
      if (needle === hay[i].type) {
        if (hay[i].homePeriod && hay[i].awayPeriod) {
          return hay[i].homePeriod + ' - ' + hay[i].awayPeriod;

        }
        return '';
      }
    }
    return '';
  };

  svs.themes.sport_floorball.getThemedExtraResult = function(match) {
    if (!match || !match.result || !_.isArray(match.result)) {
      logger.warn(
        'Invalid parameter to getThemedExtraResult, returning empty string.'
      );
      return '';
    }

    var periods = svs.themes.constants;
    var resultStr = '(';

    var sortOrder = [
      periods.PERIOD1,
      periods.PERIOD2,
      periods.PERIOD3,
      periods.EXTRA_TIME,
      periods.PENALTIES
    ];
    match.result.sort(function(result1, result2) {
      var type1 = sortOrder.indexOf(result1.type);
      var type2 = sortOrder.indexOf(result2.type);

      if (type1 === -1 && type2 === -1) {
        return 0;
      } else if (type2 === -1) {
        return -1;
      } else if (type1 === -1) {
        return 1;
      }
      return type1 - type2;
    });

    _.each(match.result, function(result) {
      if (!result) {
        return;
      }

      var type = result.type;

      if (
        _.contains(
          [
            periods.PERIOD1,
            periods.PERIOD2,
            periods.PERIOD3,
            periods.EXTRA_TIME,
            periods.PENALTIES
          ],
          type
        )
      ) {
        if (result.homePeriod >= 0 && result.awayPeriod >= 0) {
          resultStr += result.homePeriod + ' - ' + result.awayPeriod + ', ';
        }
      }
    });

    resultStr = resultStr.substr(0, resultStr.length - 2);
    if (resultStr.length) {
      resultStr += ')';
    }

    return resultStr;
  };

  svs.themes.sport_floorball.filterEvents = function(eventList) {
    if (!_.isArray(eventList)) {
      logger.warn(
        'Invalid parameter to filterEvents, returning null.',
        eventList
      );
      return null;
    }

    var types = svs.themes.constants.eventTypes;
    for (var i = 0; i < eventList.length; i++) {
      if (
        eventList[i].type === 'matcheventitem' &&
        (eventList[i].eventType === types.GOAL ||
          eventList[i].eventType === types.PENALTY)
      ) {
        eventList.splice(i, 1);
        i--;
      }
    }
    return eventList;
  };

  svs.themes.sport_floorball.reverseSortAttr = function(response, attr) {
    var items = response;
    items = _.sortBy(items, function(item) {
      return parseInt(item[attr], 10);
    }).reverse();

    return items;
  };

  svs.themes.sport_floorball.reverseSortAttrOnTime = function(response) {
    var items = response,
      _self = this;
    items = _.sortBy(items, function(item) {
      return _self.useAvailableTime(item);
    }).reverse();

    return items;
  };

  svs.themes.sport_floorball.useAvailableTime = function(item) {
    if (_.isObject(item.extendedTime)) {
      if (_.isString(item.extendedTime.time)) {
        return parseInt(item.extendedTime.time.replace(':', ''), 10);
      }
    } else if (_.isString(item.time)) {
      return parseInt(item.time, 10);
    }
    return null;
  };

  svs.themes.sport_floorball.isLazy = function(model) {
    var isLazy = false, 
      status,
      isFinished,
      startTime,
      diff,
      minutesUntilLazy = 60 * 6;

    if (!model || !model.get) {
      logger.warn('Invalid parameter to isLazy, returning false.');
      return isLazy;
    }

    status = model.get('status');
    startTime = model.get('actualStartTime') || model.get('startTime');
    isFinished = svs.themes.sport_floorball.isFinished(status);
    diff = svs.themes.getDifferenceBetweenDates(
      Date.now(),
      startTime,
      'minutes'
    );

    if (
      status === 26  ||
      (!isFinished && diff >= minutesUntilLazy)
    ) {
      isLazy = true;
    }

    return isLazy;
  };

  svs.themes.sport_floorball.formatedMatchResult = function(
    match,
    homeOrAway,
    showHyphen
  ) {
    match = match || {};
    var homeResult = showHyphen ? '-' : '',
      awayResult = showHyphen ? '-' : '';

    if (match.result && match.result.length > 0) {
      var result = svs.utils.result.getResult(match);

      if (!result && typeof match.result === 'object') {
        result = match.result;
      }
      if (result) {
        homeResult = result.home;
        awayResult = result.away;
      }
    } else if (!!(match || {}).homeTeam && !!(match || {}).awayTeam) {
      homeResult = match.homeTeam.result ? match.homeTeam.result : homeResult;
      awayResult = match.awayTeam.result ? match.awayTeam.result : awayResult;
    }
    if (homeOrAway === 'home') {
      return homeResult;
    } else if (homeOrAway === 'away') {
      return awayResult;
    }
    if (homeResult === '' || awayResult === '') {
      return ' - ';
    }
    return homeResult + ' - ' + awayResult;
  };

  svs.themes.sport_floorball.hasResultOrLazy = function(match, isLazy) {
    if (isLazy) {
      return true;
    }

    match = match || {};
    if (match.result && match.result.length > 0) {
      var result = svs.utils.result.getResult(match);

      if (result) {
        return true;
      }
    }

    return false;
  };

  svs.themes.sport_floorball.hasPenalties = function(events) {
    return !!(events && events.shootout && events.shootout.events);
  };

  svs.themes.sport_floorball.getFullTimeResult = function(match) {
    if (match && match.result) {
      return _.findWhere(match.result, {
        type: 2
      });
    }
    return false;
  };

  function _getShootout(response) {

    var shootout = {};

    var events = _.filter(response.events.chronologicalList, function(event) {
      return event.extendedTime.period === 5;
    });

    if (!events.length) {
      return false;
    }


    shootout.events = _getShootoutEvents(events);
    shootout.events = _.map(shootout.events, _addTeamName, response);
    shootout.result = _getShootoutResult(shootout.events);

    return shootout;

    function _getShootoutResult(events) {
      var result = {
        home: 0,
        away: 0
      };

      _.each(events, function(event) {
        if (
          event.eventType ===
          svs.themes.constants.eventTypes.PENALTY_SHOT_SCORES
        ) {
          if (event.home) {
            result.home++;
          } else {
            result.away++;
          }
        }
      });

      return result;
    }

    function _addTeamName(event) {
      if (event.teamId) {
        event.teamName =
          event.teamId === this.events.homeTeam.id
            ? this.events.homeTeam.name
            : this.events.awayTeam.name;
        event.home = event.teamId === this.events.homeTeam.id;
      }

      return event;
    }

    function _getShootoutEvents(list) {
      return _.filter(list, function(event) {
        return event.eventType === svs.themes.constants.eventTypes.GOAL;
      }).reverse();
    }
  }
})(svs, _);

 })(window);